const IngredientOptions = {
  Recommended: [
    'Yeast',
    'Water',
    'Salt',
    'Eggs',
    'Egg Whites',
    'Egg Yolks',
    'Olive Oil',
    'Sugar',
    'Honey',
    'Butter'
  ]
}

IngredientOptions.install = function(Vue) {
  Vue.prototype.$ingredientOptions = key => {
    return IngredientOptions[key]
  }
}

export default IngredientOptions
